import React from 'react';
import Layout from '../global/Layout';
import ChecksList from './ChecksList';
import { useTranslation } from 'react-i18next';

const PersonalChecksPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Layout showSidebar>
      <h1>{t('pages.personalChecks.title')}</h1>

      <ChecksList variant='personal' />
    </Layout>
  );
};

export default PersonalChecksPage;
